import { useEffect, useState } from 'react';

import DynamicPropertyMain from '../../DynamicProperty/DynamicPropertyMain';
import useSaveView from '../../../hooks/useSaveView';
import useView from '../../../hooks/useView';
import addNotification from '../../../utils/addNotification';
import { NotificationType } from '../../../config';
import { CheckboxUI, DeleteDialogUI, FileTabUI, TabsUI } from '../../Interface';
import resourceTwoService from '../../../service/resources/resourceTwo.service';
import resourceThreeService from '../../../service/resources/resourceThree.service';
import ExcelImportTab from '../../Interface/ExcelImportTab';
import { JokerTypes } from '../../../config/joker';
import JokerTab from '../../Interface/Joker/JokerTab';
import jokerService from '../../../service/joker.service';

const PropertyGroups = (props) => {
  const { propertyGroups, groupState, user } = props;
  const { group, setGroup } = groupState;
  const saveView = useSaveView(user);
  const savedGroups = useView('resourceThreePage', user);

  const handleCheckboxChange = (id) => {
    setGroup((prevGroup) => {
      const isSelected = prevGroup.id.includes(id);
      const updatedIds = isSelected ? prevGroup.id.filter((groupId) => groupId !== id) : [...prevGroup.id, id];

      const newGroup = { ...prevGroup, id: updatedIds };

      saveView('resourceThreePage', { dynGroup: updatedIds });

      return newGroup;
    });
  };

  useEffect(() => {
    if (Object.keys(savedGroups).length > 0) {
      setGroup((prevGroup) => ({
        ...prevGroup,
        id: savedGroups.dynGroup,
      }));
    }
  }, [savedGroups]);

  return (
    <div className="flex -mt-5 flex-wrap">
      {propertyGroups.length > 0 &&
        propertyGroups.map((groupItem) => (
          <div key={groupItem.id}>
            <CheckboxUI
              label={groupItem.name}
              checked={group.id.includes(groupItem.id)}
              onChange={() => handleCheckboxChange(groupItem.id)}
            />
          </div>
        ))}
    </div>
  );
};

const ResoureThreeTabs = (props) => {
  const { user, selectedValues, setSelectedValues, disabled, setRefetchTable } = props;
  const [activeTab, setActiveTab] = useState(0);
  const [removeElement, setRemoveElement] = useState(null);
  const [deleteDialog, setDeletDialog] = useState(false);
  const [jokerGroups, setJokerGroups] = useState([]);

  const getJokerGroups = async () => {
    jokerService.getGroups(JokerTypes.RESOURCETHREE).then((data) => {
      setJokerGroups(data);
    });
  };

  useEffect(() => {
    getJokerGroups();
  }, []);

  const handleUpload = (files) => {
    if (!selectedValues.id) {
      return addNotification({
        content: 'Nincs kiválasztott elem!',
        type: NotificationType.ERROR,
      });
    }

    const uploadPromises = files.map((file) =>
      resourceThreeService.uploadFile(file, selectedValues.id, user.userId).then((data) => {
        setSelectedValues((prev) => ({ ...prev, resourceThreeAttachment: data }));
      })
    );

    Promise.all(uploadPromises)
      .then(() => {
        setRefetchTable(true);
      })
      .catch((error) => {
        console.error('Fájl feltöltési hiba:', error);
      });
  };

  const handleDelete = (data) => {
    setRemoveElement(data.id);
    setDeletDialog(true);
  };

  const hideDeleteDialog = () => {
    setDeletDialog(false);
    setRefetchTable(true);
  };

  const handleRemoveElement = (data) => {
    resourceThreeService.deleteFile(removeElement, user.userId).then((data) => {
      setRefetchTable(true);
      setSelectedValues((prev) => ({ ...prev, resourceThreeAttachment: data }));
      hideDeleteDialog();
    });
  };

  const tabs = [
    {
      id: 0,
      name: 'Tulajdonságok',
      content: (
        <div>
          <PropertyGroups {...props} />
          <DynamicPropertyMain {...props} />
        </div>
      ),
      key: 'PROPERTIES',
    },
    {
      id: 1,
      name: 'Csatolmányok',
      content: (
        <FileTabUI
          disabled={disabled}
          handleUpload={handleUpload}
          handleDelete={handleDelete}
          savedFiles={selectedValues.resourceThreeAttachment ?? []}
        />
      ),
    },
    {
      id: 2,
      name: 'Adat import',
      content: <ExcelImportTab {...props} />,
    },
    ...((jokerGroups.length > 0 &&
      jokerGroups
        .filter((group) => group.jokerFields.length > 0)
        .map((group, index) => ({
          id: index + 3,
          name: group.name,
          content: <JokerTab fields={group.jokerFields} key={index} {...props} />,
        }))) ||
      []),
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="my-4 mt-6">
      <div className="px-3">
        <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
          {tabs.map((tab, index) => (
            <div key={index} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
      <DeleteDialogUI handleRemoveElement={handleRemoveElement} show={deleteDialog} onHide={() => hideDeleteDialog()} />
    </div>
  );
};

export default ResoureThreeTabs;
